import { Household, HouseholdMember, InviteHouseholdMemberRequest } from '@/models/Household';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getHousehold = async (): Promise<Household> => {
  const url = '/household';

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<Household>(url);

  return response.data;
};

export const inviteHouseholdMember = async (
  data: InviteHouseholdMemberRequest,
): Promise<HouseholdMember> => {
  const url = '/household/members';

  logger.debug(`POST ${url}`);
  const response = await apiClient.post<HouseholdMember>(url, data);

  return response.data;
};

export const removeHouseholdMember = async (memberId: string): Promise<void> => {
  const url = `/household/members/${encodeURIComponent(memberId)}`;

  logger.debug(`DELETE ${url}`);
  await apiClient.delete(url);
};
